import { render, staticRenderFns } from "./AddonGroups.vue?vue&type=template&id=7bcc8152&scoped=true"
import script from "./AddonGroups.vue?vue&type=script&lang=js"
export * from "./AddonGroups.vue?vue&type=script&lang=js"
function injectStyles (context) {
  
  var style0 = require("./AddonGroups.vue?vue&type=style&index=0&id=7bcc8152&prod&scoped=true&lang=css")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "7bcc8152",
  null
  ,true
)

export default component.exports